<template lang="pug">
el-container
  el-header(height='20px')
    p(v-if="fileQueue.length > 0") {{$t('Media conversions in progress')}}
    p(v-else) {{$t('No media conversions')}}
    hr.header
  .file-container
    .file-row
      .cell.progress {{ $t('Progress') }}
      .cell.network-name {{ $t('Network') }}
      .cell.mime-type {{ $t('Mime type') }}
      .cell.mime-type {{ $t('File size') }}
      .cell.operations
  .file-container
    .file-row(
        v-for="file in fileQueue",
        :key="file.id",
      )
      .cell.progress
        el-progress(v-if='file.convertionProgress < 100', :percentage='parseInt(file.convertionProgress)', color='#0071ff')
        span {{ file.originalfilename }} - {{ $moment(file.createdAt).format('HH:mm:ss.SSS') }}
      .cell.network-name
        span {{ file.Network.name }}
      .cell.mime-type
        span {{ file.originalMimeType }}
      .cell.mime-type
        span {{ humanFileSize(file.originalSize) }}
      .cell.operations(v-if="userIsAdmin")
        el-button(:id="'FileList-deleteFileButton' + file.id" size="mini", type='text', @click='deleteFile(file)')
          font-awesome-icon(icon="trash")
</template>

<script>
import Vue from 'vue'
import FileShortInfo from './ShortInfo'
import ListItemMixin from '../Medium/ListItem.mixin'
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [ListItemMixin, textUtils],
  props: ['side'],
  components: {
    FileShortInfo
  },
  created () {
    this.loadData()
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.loadData()
    }, 5000)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  data () {
    return {
      errors: {
      },
      fileQueue: [],
      loading: false,
      interval: null
    }
  },
  methods: {
    async loadData () {
      if (this.loading === false) {
        this.loading = true
        this.fileQueue = (await Vue.axios.get('file/listQueued')).data
        this.loading = false
      }
      // this.$store.dispatch('File/activateWsListener')
      this.$store.dispatch('File/filesWhereSeen')
    },
    reloadData () {
      this.loadData()
    },
    async deleteFile (file) {
      this.isSaving = true
      await Vue.axios
        .post(`file/destroyConversion`, { id: file.id })
        .then(response => {
          this.loadData()
        })
    }
  },
  computed: {
    // FIXME DRY
    userRoleNames () {
      return this.$store.state.User.user.Roles.map(role => role.name)
    },
    userIsAdmin () {
      return this.userRoleNames.includes('superadministrator') || this.userRoleNames.includes('administrator')
    },
    userIsSuperAdmin () {
      return this.userRoleNames.includes('superadministrator')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.file-container {
  color: $--color-text-regular;
  font-size: $--font-size-base;
  .file-row {
    padding: 5px;
    display: flex;
    border-bottom: $--border-light;
    align-items: center;
    justify-content: space-between;

  }
}
.cell {
  border: 0px solid red;
  width: 10%;
  &.progress {
    width:40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/File/FilesInQueue.vue